export const SMALL_SCREEN_WIDTH = 768
export const CARDS_PER_PAGE = 10
